import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'fr',
  months: [
    'janvier',
    'février',
    'mars',
    'avril',
    'mai',
    'juin',
    'juillet',
    'août',
    'septembre',
    'octobre',
    'novembre',
    'décembre',
  ],
  monthsShort: ['janv.', 'fév.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'],
  weekdays: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
  weekdaysMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
  weekdaysShort: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY, HH:mm',
    'LLL-Y': 'D MMMM, HH:mm',
    LLLL: 'dddd D MMMM YYYY, HH:mm',
    'LLLL-Y': 'dddd D MMMM, HH:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    'll-D': 'MMM YYYY',
    lll: 'D MMM YYYY, HH:mm',
    'lll-Y': 'D MMM, HH:mm',
    llll: 'ddd D MMM YYYY, HH:mm',
    'llll-Y': 'ddd D MMM, HH:mm',
    'll-Y+w': 'ddd D MMM',
    'LT+to': 'HH:mm ([UTC]Z)',
    'LLL+to': 'D MMMM YYYY, HH:mm ([UTC]Z)',
  },
  meridiem: { am: 'a.m.', pm: 'p.m.', AM: 'a.m.', PM: 'p.m.' },
  past: {
    y: { one: 'il y a %s an', other: 'il y a %s ans' },
    M: { one: 'il y a %s mois', other: 'il y a %s mois' },
    w: { one: 'il y a %s sem.', other: 'il y a %s sem.' },
    d: { one: 'il y a %s j', other: 'il y a %s j' },
    h: { one: 'il y a %s h', other: 'il y a %s h' },
    m: { one: 'il y a %s min', other: 'il y a %s min' },
    s: { one: 'il y a %s s', other: 'il y a %s s' },
  },
  future: {
    y: { one: 'dans %s an', other: 'dans %s ans' },
    M: { one: 'dans %s mois', other: 'dans %s mois' },
    w: { one: 'dans %s sem.', other: 'dans %s sem.' },
    d: { one: 'dans %s j', other: 'dans %s j' },
    h: { one: 'dans %s h', other: 'dans %s h' },
    m: { one: 'dans %s min', other: 'dans %s min' },
    s: { one: 'dans %s s', other: 'dans %s s' },
  },
  pastLong: {
    y: { one: 'il y a %s an', other: 'il y a %s ans' },
    M: { one: 'il y a %s mois', other: 'il y a %s mois' },
    w: { one: 'il y a %s semaine', other: 'il y a %s semaines' },
    d: { one: 'il y a %s jour', other: 'il y a %s jours' },
    h: { one: 'il y a %s heure', other: 'il y a %s heures' },
    m: { one: 'il y a %s minute', other: 'il y a %s minutes' },
    s: { one: 'il y a %s seconde', other: 'il y a %s secondes' },
  },
  futureLong: {
    y: { one: 'dans %s an', other: 'dans %s ans' },
    M: { one: 'dans %s mois', other: 'dans %s mois' },
    w: { one: 'dans %s semaine', other: 'dans %s semaines' },
    d: { one: 'dans %s jour', other: 'dans %s jours' },
    h: { one: 'dans %s heure', other: 'dans %s heures' },
    m: { one: 'dans %s minute', other: 'dans %s minutes' },
    s: { one: 'dans %s seconde', other: 'dans %s secondes' },
  },
  abbr: {
    y: { one: '%s an', other: '%s ans' },
    M: { one: '%s mois', other: '%s mois' },
    w: { one: '%s sem.', other: '%s sem.' },
    d: { one: '%s j', other: '%s j' },
    h: { one: '%s h', other: '%s h' },
    m: { one: '%s min', other: '%s min' },
    s: { one: '%s s', other: '%s s' },
  },
  full: {
    y: { one: '%s an', other: '%s ans' },
    M: { one: '%s mois', other: '%s mois' },
    w: { one: '%s semaine', other: '%s semaines' },
    d: { one: '%s jour', other: '%s jours' },
    h: { one: '%s heure', other: '%s heures' },
    m: { one: '%s minute', other: '%s minutes' },
    s: { one: '%s seconde', other: '%s secondes' },
  },
  justNow: "À l'instant",
  yesterday: 'Hier',
  today: "Aujourd'hui",
  tomorrow: 'Demain',
  weekStart: 1,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: {},
  timeRangeStyles: {
    yl: { start: 'D MMMM YYYY', end: 'D MMMM YYYY' },
    'yl-1': { start: 'D MMMM', end: 'D MMMM YYYY' },
    ml: { start: 'D MMMM', end: 'D MMMM' },
    'ml-1': { start: 'D', end: 'D MMMM YYYY' },
    dl: { start: 'D', end: 'D MMMM' },
    y: { start: 'D MMM YYYY', end: 'D MMM YYYY' },
    'y-1': { start: 'D MMM', end: 'D MMM YYYY' },
    m: { start: 'D MMM', end: 'D MMM' },
    'm-1': { start: 'D', end: 'D MMM YYYY' },
    d: { start: 'D', end: 'D MMM' },
    Y: { start: 'ddd D MMM YYYY', end: 'ddd D MMM YYYY' },
    'Y-1': { start: 'ddd D MMM', end: 'ddd D MMM YYYY' },
    M: { start: 'ddd D MMM', end: 'ddd D MMM' },
    D: { start: 'ddd D MMM', end: 'ddd D MMM' },
    yt: { start: 'D MMM YYYY, HH:mm', end: 'D MMM YYYY, HH:mm' },
    mt: { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm' },
    dt: { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'D MMM YYYY, HH:mm', end: 'D MMM YYYY, HH:mm ([UTC]Z)' },
    'mt+to': { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm ([UTC]Z)' },
    'dt+to': { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm ([UTC]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([UTC]Z)' },
  },
};
const localeName: LocaleName = 'fr';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => {
    const o = n === 1 ? 'er' : '';
    return `${n}${o}`;
  },
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'a.m.' : 'a.m.';
    } else {
      return isLowerCase ? 'p.m.' : 'p.m.';
    }
  },
};
